import axios from 'axios';


export const InitialiseCSRFToken = (token) =>{
    axios.defaults.headers.post['X-CSRF-Token'] = token;
    axios.defaults.headers.put['X-CSRF-Token'] = token;
    axios.defaults.headers.delete['X-CSRF-Token'] = token;
}


export const GET = (url, redirUrl = null) => {
    return axios.get(`${url}`).catch(function(error){
        console.log("Error response data",error.response.data);
        console.log("Error response status", error.response.status);
        if(redirUrl != null){
            window.location.href = redirUrl;
        }
    });
}

export const POST = (url, data) => {
    return axios(`${url}`, {
        method: 'POST',
        data,
    });
}

export const DELETE = url => {
    return axios.delete(`${url}`).catch(function (error) {
        console.log("Error response data", error.response.data);
        console.log("Error response status", error.response.status);
    });
}

const getFileName =(response) =>{
    let headerLine = response.headers['content-disposition'];
    let startFileNameIndex = headerLine.indexOf("=") + 1
    let endFileNameIndex = headerLine.lastIndexOf(";");
    let filename = headerLine.substring(startFileNameIndex, endFileNameIndex);
    return filename;
}

export const GET_DOWNLOAD = (url)=>{
    axios.get(url,{responseType: 'blob'}).then((response)=>{
        const fileName = getFileName(response);
        const url = window.URL.createObjectURL(new Blob([response.data]));

        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
    })
      
}